import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/useEntity';
import { fmt } from '../lib/formatters';

type ParametroRow = {
  clave: string;
  valor: string;
  tipo: string | null;
  descripcion: string | null;
  updated_at?: string | null;
};

/**
 * Lectura compacta del parámetro `precio_contenedor_eur` (precio del
 * contenedor 40HQ que GAME usa hoy en la calculadora). El CEO lo quería
 * visible en el header al lado del cambio USD-EUR. Click → /admin/parametros
 * para editar.
 */
export function ContenedorWidget() {
  const navigate = useNavigate();
  const q = useQuery({
    queryKey: ['list', '/admin/parametros', 'precio_contenedor_eur'],
    queryFn: () => api.get<ParametroRow>('/admin/parametros/precio_contenedor_eur'),
    staleTime: 60_000,
  });
  const valor = q.data?.valor != null ? Number(q.data.valor) : null;
  return (
    <button
      type="button"
      onClick={() => navigate('/admin/parametros')}
      title="Editar en Administración → Parámetros globales"
      className="flex cursor-pointer items-center gap-2 rounded-md border border-slate-200 bg-white px-2.5 py-1 text-xs hover:bg-slate-50"
    >
      <span className="font-medium text-slate-500">Ref. 40HQ</span>
      <span className="font-mono font-semibold text-slate-900">
        {Number.isFinite(valor) && valor != null ? fmt.eur(valor) : '—'}
      </span>
    </button>
  );
}
